import type { ComponentProps, ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { OnOffSwitch, OnOffSwitchSize } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

const ContactsRevealedToggle = (
    toggleProps: Pick<ComponentProps<typeof OnOffSwitch>, "isSelected" | "onClick" | "isDisabled">,
): ReactElement => {
    return (
        <Flex
            paddingX="0 4px"
            gap="2px"
            alignContent="center"
        >
            <OnOffSwitch
                size={OnOffSwitchSize.medium}
                {...toggleProps}
            />
            <Text
                fontVariant="body1"
                color={colorsPalettes.carbon[300]}
            >
                {translate("si.contacts_search.revealed-toggle.label")}
            </Text>
        </Flex>
    );
};

export default ContactsRevealedToggle;
